import { Cross } from '@cleartrip/bento/components/Icon/iconComponents/Cross';
import React, { useState, useEffect } from 'react'

const FeatureWidget = ({
    icon,
    width = '100%',
    height = 'auto',
    bgColor = '#FFF1EC',
    title = '',
    subText = '', 
    className,
    onActionClick = {},
    actionLabel,
    isCrossEnabled = false,
    onCrossClick = {}
}) => {
    
    return (
        <div className={`flex flex-middle flex-between flex-row w-100p br-6 px-4 py-3 ${className}`} style={{ background: bgColor, width: width, height: height }}>
            <div className='flex flex-row'>
                <img
                    src={icon}
                    alt = 'Feature Logo'
                />
                <div className='ml-4 mr-2'>
                        <img
                            src={title}
                            alt = 'Feature Title'
                        /> 
                    <div className='fs-3 fw-400'>
                        {subText}
                    </div>
                </div>
            </div>
            <div className='px-3 py-2 fs-3 flex flex-center flex-middle flex-no-shrink c-pointer ba bc-neutral-900 br-6 fw-600'
                style={{ maxHeight: '32px', maxWidth: '102px' }}
                onClick={onActionClick}
            >
                {actionLabel}
            </div>
            {isCrossEnabled && 
                <div className='ml-2 c-pointer'>
                    <Cross height={20} width={20} fill='#808080' onClick={onCrossClick}/>
                </div>
            }
        </div>
    )
    
}

export default FeatureWidget